
import Vue, { PropType } from "vue";
import { ContactPeppolEndpoint } from "@/models/base/contact-peppol-endpoint";
import AppPeppolEndpointInput from "./PeppolEndpointInput.vue";

export default Vue.extend({
	data() {
		return {
			modalOpen: false,
			editingIndex: null as number | null,
			draft: new ContactPeppolEndpoint()
		};
	},
	props: {
		value: {
			type: Array as PropType<ContactPeppolEndpoint[]>,
			default: () => []
		},
		fallbackVat: {
			type: String,
			default: ""
		}
	},
	computed: {
		endpoints():ContactPeppolEndpoint[] {
			return this.value;
		},
		draftFullID():string {
			return this.draft.getFullID();
		},
		canSaveDraft():boolean {
			return !!this.draft.Number;
		}
	},
	methods: {
		removeEndpoint(index:number) {
			let next = this.endpoints.slice();
			let removed = next.splice(index, 1)[0];
			if (removed.IsDefault && next.length > 0) {
				next[0].IsDefault = true;
			}
			this.$emit("input", next);
			this.$emit("blur");
		},
		openAddModal() {
			this.editingIndex = null;
			this.draft = new ContactPeppolEndpoint();
			if (this.endpoints.length === 0) {
				this.draft.IsDefault = true;
			}
			this.modalOpen = true;
		},
		openEditModal(index:number) {
			this.editingIndex = index;
			let source = this.endpoints[index];
			let copy = new ContactPeppolEndpoint();
			copy.SchemeID = source.SchemeID;
			copy.Number = source.Number;
			copy.Label = source.Label;
			copy.IsDefault = source.IsDefault;
			this.draft = copy;
			this.modalOpen = true;
		},
		closeModal() {
			this.modalOpen = false;
			this.editingIndex = null;
		},
		onDraftEndpointInput(fullID:string) {
			let colonIndex = fullID.indexOf(":");
			if (colonIndex > 0 && /^\d{4}$/.test(fullID.substring(0, colonIndex))) {
				this.draft.SchemeID = fullID.substring(0, colonIndex);
				this.draft.Number = fullID.substring(colonIndex + 1);
			} else {
				this.draft.SchemeID = "";
				this.draft.Number = fullID;
			}
		},
		saveDraft() {
			let next = this.endpoints.slice();
			if (this.draft.IsDefault) {
				for (let ep of next) {
					ep.IsDefault = false;
				}
			}
			if (this.editingIndex === null) {
				next.push(this.draft);
			} else {
				next.splice(this.editingIndex, 1, this.draft);
			}
			if (!next.some(e => e.IsDefault) && next.length > 0) {
				next[0].IsDefault = true;
			}
			this.$emit("input", next);
			this.$emit("blur");
			this.closeModal();
		}
	},
	components: {
		AppPeppolEndpointInput
	},
	i18nEx: {
		componentPrefix: "components.peppol.endpoints-editor"
	}
});
